import { Dispatch } from 'redux';
import { ReduxAction } from '../../../ReduxStorage/actions';
import {
  currentCohortPathSelector,
  currentUserIdSelector,
} from '../../../ReduxStorage/Auth/selectors';
import { selectCurrentCoursePath } from '../../../ReduxStorage/Courses/selectors';
import { COURSE } from '../../../ReduxStorage/resourceNames';
import { ReduxState } from '../../../ReduxStorage/state';
import {
  CourseResource,
  CourseResourceCreateUserConsent,
  CourseResourceFetchHasEnrolmentConsentPermission,
} from '../../../resource/CourseResource/types';
import { ResourceApi } from '../../../resource/Resource';
import { ActionTypes } from './actions';
import './injectReducers';

export const fetchLearnerHasEnrolmentConsentPermission = () => (
  dispatch: Dispatch<ReduxAction>,
  getState: () => ReduxState
): Promise<void> => {
  const cohortPath = currentCohortPathSelector(getState());
  if (cohortPath) {
    const coursePath = selectCurrentCoursePath(getState());

    dispatch({
      type: ActionTypes.FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_START,
    });
    return ResourceApi.read<
      CourseResource,
      CourseResourceFetchHasEnrolmentConsentPermission
    >(COURSE, coursePath, [
      {
        method: 'hasEnrolmentConsentPermission',
        args: {},
      },
    ]).then((response) => {
      dispatch({
        type: ActionTypes.FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS,
        hasEnrolmentConsentPermission: response[0],
      });
    });
  }
  return Promise.resolve();
};

export const updateLearnerHasEnrolmentConsentPermission = () => (
  dispatch: Dispatch<ReduxAction>,
  getState: () => ReduxState
): void => {
  const coursePath = selectCurrentCoursePath(getState());
  const currentUserId = currentUserIdSelector(getState());

  dispatch({
    type: ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_START,
  });

  ResourceApi.update<CourseResource, CourseResourceCreateUserConsent>(
    COURSE,
    coursePath,
    'createUserConsent',
    {
      userId: currentUserId,
    }
  )
    .then(() => {
      dispatch({
        type:
          ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS,
      });
    })
    .catch(() => {
      dispatch({
        type:
          ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_FAILED,
        error: 'There was a problem when updating consent permission',
      });
    });
};
